import axios from 'axios';
import { get } from 'lodash';
import { datadogLogs } from '@datadog/browser-logs';

interface options {
  url: String;
  method: String;
  params?: Object;
  data?: Object;
}

interface error {
  response: any;
  message: string;
}

// axios.defaults.withCredentials = true;

let createInstance = async (
  options: Object,
  onSuccess: any,
  onError: any,
  v1: boolean | string,
  token: any,
) => {
  const accessToken = token;
  let url;
  switch (v1) {
    case true:
      {
        url = process.env.REACT_APP_NEW_BASE_URL;
      }
      break;
    case 'v_d2': {
      url = process.env.REACT_APP_V_D2;
      break;
    }
    case false:
      {
        url = process.env.REACT_APP_BASE_URL;
      }
      break;
    case 'base_v2':
      {
        url = process.env.REACT_APP_BASE_URL;
      }
      break;
    case 'analytics':
      {
        url = process.env.REACT_APP_ANALYTICS_URL;
      }
      break;
    case 'analytics_v2':
      {
        url = process.env.REACT_APP_ANALYTICS_URL_V2;
      }
      break;
    case 'new_base_v2':
      url = process.env.REACT_APP_NEW_BASE_URL_V2;
      break;
    case 'new_base_v3':
      url = process.env.REACT_APP_NEW_BASE_URL_V3;
      break;
    case 'new_base_v4':
      url = process.env.REACT_APP_NEW_BASE_URL_V4;
      break;
    case 'shifts_v1':
      url = process.env.REACT_APP_BASE_URL_SHIFTS;
      break;
    case 'easy_store_2':
      url = process.env.REACT_APP_NEW_BASE_URL_ES_V2;
      break;
    case 'easy_store':
      url = process.env.REACT_APP_NEW_BASE_URL_ES_V2;
      break;
    default: {
      url = process.env.REACT_APP_NEW_BASE_URL;
    }
  }
  let client;
  if (v1 === 'easy_store' || v1 === 'base_v2') {
    client = axios.create({
      baseURL: url,
      timeout: 800000,
      headers: {
        Accept: 'application/json, multipart/form-data; charset=utf-8',
        'Content-Type': 'multipart/form-data',
        'X-Authorization': 'Token ' + accessToken,
      },
    });
  } else if (accessToken) {
    client = axios.create({
      baseURL: url,
      timeout: 800000,
      headers: {
        Accept: 'application/json; charset=utf-8',
        'Content-Type': 'application/json',
        'X-Authorization': 'Token ' + accessToken,
      },
    });
  } else {
    client = axios.create({
      baseURL: url,
      timeout: 800000,
      headers: {
        Accept: 'application/json; charset=utf-8',
        'Content-Type': 'application/json',
      },
    });
  }

  return client(options).then(onSuccess).catch(onError);
};

const request = (requestOptions: any) => {
  const { params, ...others } = requestOptions;
  const { v1 = false, token = null, ...rest } = params;
  let options = { ...others, params: rest };

  const onSuccess = (response: any) => {
    return response;
  };

  const onError = async (error: error) => {
    datadogLogs.logger.error('Request ErrorHandler', error);
    //onErrors called different navigatin methods
    let e_401 = [];
    if (error?.response?.status) {
      switch (error.response.status) {
        case 400: {
          console.log(
            'jnsnsmn',
            typeof get(error, 'response.data.error', ''),
            get(error, 'response.data.error', ''),
            error.response,
          );
          throw get(error, 'response.data.error', '');
          //    { error: true, message: get(error, 'response.data.error', '') };
        }
        case 401:
          {
            e_401.push('error');
            if (e_401.indexOf('error') !== -1) {
              //   Alert.alert(
              //     'Session Expired',
              //     'To keep account secured, we logged you out due to inactivity',
              //     [
              //       {
              //         text: 'Relogin',
              //         onPress: async () => {
              //           await cacheService.clear();
              //           preLogin();
              //         },
              //         style: 'cancel',
              //       },
              //     ],
              //     { cancelable: false },
              //   );
            }
          }
          throw 'error';
        case 403: {
          console.log(error);
          throw error.message;
        }
        case 500: {
          throw 'err';
        }
      }
    } else return Promise.reject(error.response || error.message);
  };

  return createInstance(options, onSuccess, onError, v1, token);
};

export default request;